import { Injectable } from '@angular/core';

import { SettingsService } from '../../services/settings/settings.service';
import * as BlipSdk from 'blip-sdk';
import * as WebSocketTransport from 'lime-transport-websocket'
import * as Lime from 'lime-js';


@Injectable()
export class ChatBlipControllerService {
    public messageReceived = null;  
    private blipWSConnection;

    // ID e Chaves referente ao Bot encontrados no Portal do Blip >> configuração >> informações de conexão
    private botId = this.settingsService.getConfigurationKeyValue('blip').botId;
    private botKey = this.settingsService.getConfigurationKeyValue('blip').botKey;

    constructor (private settingsService: SettingsService) {}

    // Inicializa uma conexão via WS com o Bot correspondente as configurações para escutar e enviar comandos e mensagens do servidor;
    public initWSConnection() {
        let client = new BlipSdk.ClientBuilder()
            .withIdentifier(this.botId)
            .withAccessKey(this.botKey)
            .withTransportFactory(() => new WebSocketTransport())
            .build();

        this.blipWSConnection = client
    
        if (this.blipWSConnection != null) {
            this.blipWSConnection.connect()
                .then((session) => {
                    // Connection success. Now is possible send and receive envelopes from server. */
                    this.blipWSConnection.addCommandReceiver(true, async(message) => {
                        if (message.resource != null) {
                            this.messageReceived = message;
                        } 
                    })
                }).catch((err) => {
                    this.blipWSConnection.close();
                });

            this.blipWSConnection.close();
        }
    }

    // Commando executado para adquirir variacel do usuário no servidor
    public getContextVariable(varName : String, identity : String)  {
        this.blipWSConnection.sendCommand({
            id: Lime.Guid(),
            to: "postmaster@msging.net",
            method: "get",
            uri: `/contexts/${identity}/${varName}`
        })
    }

    // Comando executado para atualizar dados do contato do usuário
    public updateContact(userPayload) {
        this.blipWSConnection.sendCommand({
            id: Lime.Guid(),
            to: "postmaster@msging.net",
            method: "set",
            uri: '/contacts',
            type: 'application/vnd.lime.contact+json',
            resource: userPayload
        })
    }

    public getBlipChatContainerElm() {
        return window.document.getElementById('blip-chat-container');
    }

    public getBlipChatElm() {
        return window.document.getElementById('blip-chat-open-iframe');
    }

    public hideChat() {
        this.getBlipChatElm().style['display'] = 'none';
    }

    public showChat() {
        this.getBlipChatElm().style['display'] = 'block';

        return this;
    }

    public openChat() {
        this.showChat()
            .getBlipChatElm()
            .click();
    }

    public dispatchWithdrawEvent(reason : string = 'default') {
        var event = new CustomEvent('BlipWidget.saque', {'detail' : reason })
        window.dispatchEvent(event)
    }

}

export default ChatBlipControllerService;